// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpdateOrganizationMembershipMutationVariables = Types.Exact<{
  membershipId: Types.Scalars["ID"]["input"];
  roleIds?: Types.InputMaybe<
    Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"]
  >;
}>;

export type UpdateOrganizationMembershipMutation = {
  __typename?: "Mutation";
  updateOrganizationMembership: {
    __typename?: "OrganizationMembership";
    id: string;
    email: string;
  };
};

export const UpdateOrganizationMembershipDocument = gql`
  mutation UpdateOrganizationMembership($membershipId: ID!, $roleIds: [ID!]) {
    updateOrganizationMembership(
      membershipId: $membershipId
      roleIds: $roleIds
    ) {
      id
      email
    }
  }
`;
export type UpdateOrganizationMembershipMutationFn = Apollo.MutationFunction<
  UpdateOrganizationMembershipMutation,
  UpdateOrganizationMembershipMutationVariables
>;

/**
 * __useUpdateOrganizationMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMembershipMutation, { data, loading, error }] = useUpdateOrganizationMembershipMutation({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *      roleIds: // value for 'roleIds'
 *   },
 * });
 */
export function useUpdateOrganizationMembershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOrganizationMembershipMutation,
    UpdateOrganizationMembershipMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOrganizationMembershipMutation,
    UpdateOrganizationMembershipMutationVariables
  >(UpdateOrganizationMembershipDocument, options);
}
export type UpdateOrganizationMembershipMutationHookResult = ReturnType<
  typeof useUpdateOrganizationMembershipMutation
>;
export type UpdateOrganizationMembershipMutationResult =
  Apollo.MutationResult<UpdateOrganizationMembershipMutation>;
export type UpdateOrganizationMembershipMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateOrganizationMembershipMutation,
    UpdateOrganizationMembershipMutationVariables
  >;
